export const CREATE_TRACKING_LINK = gql`
  mutation createTrackingLink($input: CreateTrackingLinkInput!) {
    createTrackingLink(input: $input) {
      trackingLinkId
      linkType
      linkName
      jobListingId
    }
  }
`

export const UPDATE_TRACKING_LINK = gql`
  mutation updateTrackingLink($id: String!, $input: UpdateTrackingLinkInput!) {
    updateTrackingLink(id: $id, input: $input) {
      trackingLinkId
      linkName
      leadEmployees {
        employeeId
      }
      memberEmployees {
        employeeId
      }
    }
  }
`

export const DELETE_TRACKING_LINK = gql`
  mutation deleteTrackingLink($id: String!) {
    deleteTrackingLink(id: $id) {
      trackingLinkId
    }
  }
`

export const GET_TRACKING_LINKS = gql`
  query getTrackingLinks($jobListingId: String!) {
    trackingLinks(
      jobListingId: $jobListingId
      pageInfo: { limit: 1000, offset: 0 }
    ) {
      items {
        trackingLinkId
        linkType
        linkName
        link
        externalPostingId
        jobSourceConnectionId
        leadEmployees {
          employeeId
        }
        memberEmployees {
          employeeId
        }
      }
      pageInfo {
        offset
        limit
      }
      totalCount
    }
  }
`

export const GET_TRACKING_LINK = gql`
  query getTrackingLink($id: String!) {
    trackingLink(id: $id) {
      trackingLinkId
      createdAt
      updatedAt
      linkStatus
      linkType
      linkName
      jobListingId
      link
    }
  }
`

export const GET_COMPANY_LEAD_SOURCES = gql`
  query getCompanyLeadSources {
    companyLeadSources {
      linkType
      linkName
    }
  }
`

export const GET_JOB_LISTING_BY_TRACKING_LINK = gql`
  query getJobListingByTrackingLink($link: String!) {
    jobListingByTrackingLink(link: $link) {
      jobListingId
      title
      type
      subtitle
      description
      benefits
      payMin
      payMax
      payUnit
      payCurrency
      employmentType
      licenseClass
      endorsements
      minMonthsExperience
      minEmploymentHistoryYears
      address {
        city
        state
      }
      company {
        companyId
        companyName
      }
      publicQuestions {
        jobListingTemplateQuestionId
        label
        fieldType
        isRequired
        placeholder
        helpText
        order
        options {
          customQuestionOptionId
          label
          order
        }
      }
    }
  }
`
